











import { Component, Prop, Vue } from 'vue-property-decorator'


@Component
export default class DisplayFields extends Vue {
    @Prop({ required: true }) value!: unknown
}
